import React, { useState, useEffect } from "react";
import Styled from "./PayPopup.styles";
import l10n from "../../localization";
import Modal from "../Modal";
import GatewayWspayForm from "../GatewayWSPAYForm";
import { Row, Col } from "reactstrap";
import Helpers from "../../helpers/helpers";
import { getPayAllSignature } from "../../redux/actions/payAll.actions";
import { connect } from "react-redux";

import maestro from "../../assets/maestro.gif";
import verifiedvisa from "../../assets/verifiedvisa.jpg";
import visa from "../../assets/visa.gif";
import wspay from "../../assets/wspay.png";
import logo from "../../assets/logo-vodovod-rijeka.png";
import { IconPayBill } from "../../components/Icons/Icons";

const PayPopup = ({ buttonLabel, invoices, ...props }) => {
  const [popupOpen, setPopupOpen] = useState(false);
  const [paymentDisabled, setPaymentDisabled] = useState(true);
  const [signatureReady, setSignatureReady] = useState(false);
  const [invoice, setInvoice] = useState({});
  const [invoicesSum, setInvoicesSum] = useState(0);

  useEffect(() => {
    if (invoices.length > 1) {
      props.getPayAllSignature({
        invoiceIds: invoices.map(invoice => invoice.invoiceId)
      });
    } else {
      setSignatureReady(true);
      setInvoice({
        invoiceId: invoices[0].invoiceId,
        invoiceValue: invoices[0].invoiceDebt,
        isPayed: invoices[0].isPayed,
        wsPaySignature: invoices[0].wsPaySignature
      });
    }

    setInvoicesSum(
      invoices.reduce(function(a, b) {
        return a + b["invoiceDebt"];
      }, 0)
    );
    //eslint-disable-next-line
  }, [invoices]);

  useEffect(() => {
    if (props.payAll.success && invoices.length > 1) {
      setSignatureReady(true);
      setInvoice({
        invoiceId: props.payAll.data.shoppingCartId,
        invoiceValue: props.payAll.data.value,
        isPayed: "Open",
        wsPaySignature: props.payAll.data.wsPaySignature
      });
    }
    //eslint-disable-next-line
  }, [props.payAll]);

  const openPopup = () => {
    setPopupOpen(true);
  };
  const closePopup = () => {
    setPopupOpen(false);
  };

  const acceptConditions = e => {
    setPaymentDisabled(!e.target.checked);
  };

  return (
    <>
      {popupOpen && (
        <Modal
          open={popupOpen}
          title={l10n.payPopup.modalTitle}
          footer={true}
          closeButtonText={l10n.payPopup.closeButton}
          onClose={closePopup}
        >
          {process.env.REACT_APP_PAYMENT === "0" && (
            <Row>
              <Col>
                <strong>
                  Poštovani korisnici aplikacije, izravno plaćanje računa
                  trenutno nije moguće.
                  <br />
                  Usluga će biti dostupna u najkraćem roku, o čemu ćemo Vas
                  izvjestiti porukom.
                </strong>
              </Col>
            </Row>
          )}
          {process.env.REACT_APP_PAYMENT === "1" && (
            <>
              <Styled.ItemLine>
                <Col>{l10n.payPopup.invoiceNumber}</Col>
                <Col align="right">{l10n.payPopup.total}</Col>
              </Styled.ItemLine>
              {invoices.map(invoiceRow => (
                <Styled.ItemLine key={invoiceRow.invoiceId}>
                  <Col>{invoiceRow.invoiceId}</Col>
                  <Col align="right">
                    {Helpers.formatPrice(invoiceRow.invoiceDebt)}
                  </Col>
                </Styled.ItemLine>
              ))}
              <Row>
                <Col />
                <Col align="right">
                  {l10n.payPopup.total2}:{" "}
                  <strong>{Helpers.formatPrice(invoicesSum)}</strong>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Styled.checkbox
                    type="checkbox"
                    name="termsAndConditions"
                    id="termsAndConditions"
                    onClick={acceptConditions}
                  />

                  <label htmlFor="termsAndConditions">
                    {l10n.payPopup.iAgree}{" "}
                    <a
                      href="https://www.google.com"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {l10n.payPopup.terms}
                    </a>
                  </label>
                </Col>
              </Row>

              <GatewayWspayForm invoice={invoice} disabled={paymentDisabled} />

              <div
                dangerouslySetInnerHTML={{ __html: l10n.payPopup.withClick }}
              />
              <Row>
                <Col>
                  <Styled.CardHolder>
                    <a
                      href="http://www.maestrocard.com/hr/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img src={maestro} alt="maestro" />
                    </a>
                    <a
                      href="https://www.wspay.info/verified-by-visa.html"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img src={verifiedvisa} alt="visa" />
                    </a>
                    <a
                      href="https://www.visa.com.hr/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img src={visa} alt="visa" />
                    </a>
                  </Styled.CardHolder>
                </Col>
              </Row>
              <p>
                {l10n.payPopup.agree}{" "}
                <a
                  href="https://www.google.com"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {l10n.payPopup.agreeTerms}
                </a>{" "}
                {l10n.payPopup.company}.
              </p>
              <h3>{l10n.payPopup.payCardsTitle}</h3>
              <p>{l10n.payPopup.payCardsDescription}</p>
              <h3>{l10n.payPopup.payCardsTitleExtra}</h3>
              <p>{l10n.payPopup.payCardsDescriptionExtra}</p>
              <Row>
                <Col align="right">
                  <a
                    href="https://www.wspay.si"
                    title="WSPay - Web Secure Payment Gateway"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img src={wspay} alt="wspay" />
                  </a>
                </Col>
              </Row>
              <hr />
              <Styled.logo src={logo} alt="moj vik" />
              <p>{l10n.payPopup.disclaimer}</p>
              <Row>
                <Col>
                  <p>
                    Vodovod Rijeka d.o.o.
                    <br />
                    Rijeka
                    <br />
                    OIB:
                    <br />
                    {l10n.payPopup.companyId}:
                    <br />
                    IBAN:
                  </p>
                </Col>
                <Col>
                  <p>
                    E-mail: <a href="mailto:email@email.com">email@email.com</a>
                    <br />
                    {l10n.payPopup.phone}:{" "}
                    <a href="tel:123">
                      123 / 123 - 123 ({l10n.payPopup.central})
                    </a>
                  </p>
                </Col>
              </Row>
            </>
          )}
        </Modal>
      )}
      <Styled.button
        onClick={openPopup}
        color="success"
        disabled={!signatureReady}
      >
        <IconPayBill></IconPayBill>
      </Styled.button>
    </>
  );
};
export default connect(({ payAll }) => ({ payAll }), { getPayAllSignature })(
  PayPopup
);
